import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useSentimentStatByThemeBlocksStore = createAnalyticsStore(
  "sentimentStatByThemeBlocksStore",
  "Analytics/block/sentiment/new/:projectId",
  { loadStatType: "sentiment" }
);